// https://www.npmjs.com/package/@react-hook/copy
import useCopy from '@react-hook/copy';
import { useDispatch } from 'react-redux';

import { setSnackbarMessage } from 'actions/snackbar';

const useCopyToClipboard = ({ snackBarOptions = {}, text = '' } = {}) => {
  const dispatch = useDispatch();
  const { copy } = useCopy(text);

  // TODO: This function should be memoized so it can be used as a dependency
  const copyToClipboard = ({ onCopyMessage = 'Copied to clipboard!' } = {}) => {
    try {
      // Use this method instead of navigator.clipboard because clipboard does
      // not exist on iOS devices https://webkit.org/blog/10855/async-clipboard-api/
      copy();
      if (onCopyMessage)
        dispatch(
          setSnackbarMessage({ ...snackBarOptions, message: onCopyMessage }),
        );
    } catch (err) {
      console.error('Error copying to clipboard: ', err);
    }
  };
  return {
    copyToClipboard,
  };
};

export default useCopyToClipboard;
